export enum CareerStatusEnum {
  Start = 'start',
  ActivatedTheme = 'activated_theme',
  InactiveTheme = 'inactive_theme',
}
